<template>
  <div class="intro">
    <div class="container">
      <div class="outer">
        <div class="inner">
          <div class="box">
            <div class="header">
              <h1 class="bi">
                보이스캐디
              </h1>
            </div>
            <div class="body">
              <h2 class="title">
                해비치 컨트리클럽 서울
              </h2>
            </div>
          </div>
        </div>
      </div>
      <div class="close">
        닫기
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'introLayout',
  data () {
    return {
    }
  },
  created: function () {
  },
  mounted: function () {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/layout/Intro.vue